"use client";

import { motion, useReducedMotion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { getRevealVariants } from "@/components/motion/variants";

interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
  /** Fraction of element that must enter viewport to reveal. Use "any" for large sections. */
  amount?: number | "any";
}

export function Reveal({ children, className, delay = 0, amount = 0.12 }: RevealProps) {
  const reduced = useReducedMotion();
  const baseVariants = getRevealVariants(reduced);
  const variants =
    delay > 0
      ? {
          ...baseVariants,
          visible: {
            ...baseVariants.visible,
            transition: {
              ...(typeof baseVariants.visible === "object" &&
              baseVariants.visible !== null &&
              "transition" in baseVariants.visible
                ? baseVariants.visible.transition
                : {}),
              delay,
            },
          },
        }
      : baseVariants;

  const viewportAmount = amount === "any" ? 0 : amount;

  return (
    <motion.div
      className={cn(className)}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: viewportAmount, margin: "0px 0px -5% 0px" }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
}
